import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import Head from 'next/head';
import React from 'react';
import { Provider } from 'react-redux';
import { ErrorBoundary } from '@uno/frontend-shared';
import AppCrashFallback from 'components/common/AppCrashFallback';
import CSSResets from 'components/common/CSSResets';
import Root from 'components/common/Root';
import { SVGGradient } from 'components/common/SVGGradient';
import { useStore } from 'redux/store';

var App = function App(_ref) {
  var Component = _ref.Component,
      hasError = _ref.hasError,
      errorEventId = _ref.errorEventId,
      pageProps = _ref.pageProps;
  var store = useStore(pageProps.initialReduxState);
  var envTitle = process.env.STAGE !== 'production' ? '(dev)' : '';
  return __jsx(ErrorBoundary, {
    FallbackComponent: AppCrashFallback,
    hasError: hasError,
    eventId: errorEventId
  }, __jsx(CSSResets, null), __jsx(SVGGradient, null), __jsx(Provider, {
    store: store
  }, __jsx(Root, null, __jsx(Head, null, __jsx("title", null, "Bako ", envTitle, " - Unify CMS"), __jsx("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "/favicon-32.png"
  }), __jsx("link", {
    rel: "icon",
    type: "image/png",
    sizes: "128x128",
    href: "/favicon-128.png"
  })), __jsx(Component, pageProps))));
};

App.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
    var Component, ctx, pageProps, errorEventId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            Component = props.Component, ctx = props.ctx;
            _context.prev = 1;

            if (!(Component.getInitialProps !== undefined)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return Component.getInitialProps(ctx);

          case 5:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;

          case 8:
            _context.t0 = {};

          case 9:
            pageProps = _context.t0;
            return _context.abrupt("return", {
              pageProps: pageProps
            });

          case 13:
            _context.prev = 13;
            _context.t1 = _context["catch"](1);
            // TODO : use NewRelic Browser to get an eventId
            errorEventId = '';
            return _context.abrupt("return", {
              hasError: true,
              errorEventId: errorEventId,
              pageProps: {}
            });

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

export default App;